models.service('OpenTradeModel', [
    '$filter', '$rootScope',  'Utils',
    'constants', 'AssetService', 'InvestCalcService', 'CurrencyConvertService', 'UserService',
    function ($filter, $rootScope, Utils,
              Const, AssetService, InvestCalcService, CurrencyConvertService, UserService) {

        function OpenTrade(positionData, asset) {
            var self = this;

            self.orderId = positionData.OrderID;
            self.asset = asset;
            self.outputName = positionData.OutputName;
            self.action = Const.actionsId[positionData.Cmd];
            self.actionCode = positionData.Cmd;
            self.openPrice = positionData.OpenPrice;
            self.openTime = parseInt(positionData.OpenTime + '000', 10);
            self.closeTime = parseInt(positionData.CloseTime + '000', 10);
            self.digits = positionData.Digits;
            self.lots = positionData.Volume;
            self.contractSize = positionData.ContractSize;
            self.amount = self.contractSize * self.lots;
            self.stopLoss = positionData.sl;
            self.takeProfit = positionData.tp;
            self.commission = positionData.Commission;
            self.taxes = positionData.Taxes;
            self.swap = positionData.Storage;

            self.symbolCurrency = self.asset.currency;
            self.comment = positionData.Comment;
            self.closePriceDirection = null;
            self.profitDirection = null;

            self.user = UserService.get();
            self.showConvertToUsd = Const["showConvertToUsd"] || false;

            self.convUSDAssets = CurrencyConvertService.find(AssetService, self.user.currency, 'USD', '', 1);

            this.closePrice = function () {
                if (self.action.match(/^sell/)) {
                    self.closePriceDirection = self.asset.askDirection;
                    return self.asset.markupAsk();
                }
                if (self.action.match(/^buy/)) {
                    self.closePriceDirection = self.asset.bidDirection;
                    return self.asset.markupBid();
                }
            };

            this.pendingCurrentPrice = function () {
                if (self.action.match(/^sell/)) {
                    self.closePriceDirection = self.asset.bidDirection;
                    return self.asset.markupBid();
                }
                if (self.action.match(/^buy/)) {
                    self.closePriceDirection = self.asset.askDirection;
                    return self.asset.markupAsk();
                }
            };

            this.profit = function () {
                var baseVal = 0;

                if ((self.action === 'buy' || self.action === 'sell') && self.closePrice() > 0) {
                    var assetCurrency = self.asset.currency,
                        pairVal = InvestCalcService.getPairVal(self.action, self.openPrice, self.closePrice(), self.digits);

                    if (self.asset.profitMode === 0) {
                        assetCurrency = self.asset.outputName.slice(-3);
                    }
                    if (self.asset.profitMode < 2) {
                        baseVal = pairVal * self.amount;
                    } else {
                        baseVal = pairVal * (self.asset.tickPrice / self.asset.tickSize) * self.lots;
                    }

                    baseVal = CurrencyConvertService.doConvert(self.asset.convAssets, baseVal, self.action, self.asset.profitMode);
                }
                self.profitDirection = parseFloat(baseVal) > 0 ? 'up' : 'down';
                return parseFloat(baseVal);
            };

            this.profitToUsd = function(){
                return  CurrencyConvertService.doConvert(self.convUSDAssets, Utils.decimalRound(self.profit(), self.user.currencyDigits), 'buy', 1);
            };

            //send event to pnlService on profit change
            /*var profitWatch = $rootScope.$watch(self.profit, function profitWatchHandler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    $rootScope.$emit('pnl');
                }
            });*/

            this.distance = function () {
                var price = 0;

                if (self.action.match(/^sell/)) {
                    price = self.openPrice - self.closePrice();
                }

                if (self.action.match(/^buy/)) {
                    price = self.closePrice() - self.openPrice;
                }

                //divide on 10 if asset's digits 3 or 5 (Forex/non-Forex)
                return (self.asset.digits === 3 || self.asset.digits === 5) ?
                    parseFloat(InvestCalcService.fromPoints(price, self.asset.digits) / 10).toFixed(1) :
                    parseInt(InvestCalcService.fromPoints(price, self.asset.digits), 10);
            };

            this.pendingDistance = function () {
                return InvestCalcService.fromPoints(Math.abs(self.pendingCurrentPrice() - self.openPrice) / 10,  self.asset.digits);
            };

            this.update = function (positionData) {
                self.asset = AssetService.collection.get({id: positionData.id});
                self.outputName = positionData.OutputName;
                self.action = Const.actionsId[positionData.Cmd];
                self.actionCode = positionData.Cmd;
                self.openPrice = positionData.OpenPrice;
                self.openTime = parseInt(positionData.OpenTime + '000', 10);
                self.closeTime = parseInt(positionData.CloseTime + '000', 10);
                self.digits = positionData.Digits;
                self.lots = positionData.Volume;
                self.contractSize = positionData.ContractSize;
                self.amount = self.contractSize * self.lots;
                self.stopLoss = positionData.sl;
                self.takeProfit = positionData.tp;
                self.commission = positionData.Commission;
                self.taxes = positionData.Taxes;
                self.swap = positionData.Storage;
                self.symbolCurrency = self.asset.currency;
                self.comment = positionData.Comment;
            };

            function noop() {
            }

            this.clear = function () {
                //profitWatch();
                self.closePrice = noop;
                self.profit = noop;
                self.distance = noop;
                self.asset = null;
                self.user = null;
            }

            this.getTrade = function() {
                return {
                    orderId: self.orderId,
                    openTime: self.openTime,
                    openPrice: self.openPrice,
                    lots: self.lots,
                    amount: self.amount,
                    symbol: self.outputName,
                    swaps: self.swap,
                    stopLoss: self.stopLoss,
                    takeProfit: self.takeProfit,
                    action: self.action,
                    profit: self.profit()
                }
            }

            this.fromSocial = function() {
                return /^S:/.test(self.comment);
            }

        }

        return OpenTrade;

    }]);
